/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParticipantRoleClaim } from './ParticipantRoleClaim';
import {
    ParticipantRoleClaimFromJSON,
    ParticipantRoleClaimFromJSONTyped,
    ParticipantRoleClaimToJSON,
    ParticipantRoleClaimToJSONTyped,
} from './ParticipantRoleClaim';
import type { ParticipantClaim } from './ParticipantClaim';
import {
    ParticipantClaimFromJSON,
    ParticipantClaimFromJSONTyped,
    ParticipantClaimToJSON,
    ParticipantClaimToJSONTyped,
} from './ParticipantClaim';
import type { ParticipantUserClaim } from './ParticipantUserClaim';
import {
    ParticipantUserClaimFromJSON,
    ParticipantUserClaimFromJSONTyped,
    ParticipantUserClaimToJSON,
    ParticipantUserClaimToJSONTyped,
} from './ParticipantUserClaim';

/**
 * 
 * @export
 * @interface ClientAllClaim
 */
export interface ClientAllClaim {
    /**
     * 
     * @type {string}
     * @memberof ClientAllClaim
     */
    clientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientAllClaim
     */
    claimType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientAllClaim
     */
    valueType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientAllClaim
     */
    description?: string | null;
    /**
     * 
     * @type {Array<ParticipantClaim>}
     * @memberof ClientAllClaim
     */
    participantClaims?: Array<ParticipantClaim> | null;
    /**
     * 
     * @type {Array<ParticipantUserClaim>}
     * @memberof ClientAllClaim
     */
    participantUserClaims?: Array<ParticipantUserClaim> | null;
    /**
     * 
     * @type {Array<ParticipantRoleClaim>}
     * @memberof ClientAllClaim
     */
    participantRoleClaims?: Array<ParticipantRoleClaim> | null;
}

/**
 * Check if a given object implements the ClientAllClaim interface.
 */
export function instanceOfClientAllClaim(value: object): value is ClientAllClaim {
    return true;
}

export function ClientAllClaimFromJSON(json: any): ClientAllClaim {
    return ClientAllClaimFromJSONTyped(json, false);
}

export function ClientAllClaimFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientAllClaim {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
        'claimType': json['claimType'] == null ? undefined : json['claimType'],
        'valueType': json['valueType'] == null ? undefined : json['valueType'],
        'description': json['description'] == null ? undefined : json['description'],
        'participantClaims': json['participantClaims'] == null ? undefined : ((json['participantClaims'] as Array<any>).map(ParticipantClaimFromJSON)),
        'participantUserClaims': json['participantUserClaims'] == null ? undefined : ((json['participantUserClaims'] as Array<any>).map(ParticipantUserClaimFromJSON)),
        'participantRoleClaims': json['participantRoleClaims'] == null ? undefined : ((json['participantRoleClaims'] as Array<any>).map(ParticipantRoleClaimFromJSON)),
    };
}

export function ClientAllClaimToJSON(json: any): ClientAllClaim {
    return ClientAllClaimToJSONTyped(json, false);
}

export function ClientAllClaimToJSONTyped(value?: ClientAllClaim | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'claimType': value['claimType'],
        'valueType': value['valueType'],
        'description': value['description'],
        'participantClaims': value['participantClaims'] == null ? undefined : ((value['participantClaims'] as Array<any>).map(ParticipantClaimToJSON)),
        'participantUserClaims': value['participantUserClaims'] == null ? undefined : ((value['participantUserClaims'] as Array<any>).map(ParticipantUserClaimToJSON)),
        'participantRoleClaims': value['participantRoleClaims'] == null ? undefined : ((value['participantRoleClaims'] as Array<any>).map(ParticipantRoleClaimToJSON)),
    };
}

